<ion-item *ngIf="userPresets" [color]="color">
  <ion-select
    [label]="label"
    labelPlacement="stacked"
    [disabled]="disabled"
    [placeholder]="label"
    [(ngModel)]="userPresets.value"
    (ngModelChange)="onModelChange()"
    interface="popover"
  >
    <ion-select-option *ngFor="let item of userPresets.data" [value]="item.value">{{ item.name }}</ion-select-option>
  </ion-select>
</ion-item>
